// This file is auto-generated by @hey-api/openapi-ts

import { type Options, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreport, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheck, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlist, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetail, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterest, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheck, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewal, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheck, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpush, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewal, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuance, postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddress, postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdream, postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclient, getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversity, getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnotice, getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistory, getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountry, getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreement, getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACE } from '../sdk.gen';
import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { SaveReportData, SaveReportError, SaveReportResponse, GetReportStatusCheckData, GetReportStatusCheckError, GetReportStatusCheckResponse, GetReportHistoryListData, GetReportHistoryListError, GetReportHistoryListResponse, GetReportHistoryData, GetReportHistoryError, GetReportHistoryResponse, GetLoanInterestListData, GetLoanInterestListError, GetLoanInterestListResponse, HealthCheckData, HealthCheckError, HealthCheckResponse, RenewalEncKeyData, RenewalEncKeyError, RenewalEncKeyResponse, GetEligibilityCheckData, GetEligibilityCheckError, GetEligibilityCheckResponse, SendDeptReportAppPushData, SendDeptReportAppPushError, SendDeptReportAppPushResponse, RenewalApiKeyData, RenewalApiKeyError, RenewalApiKeyResponse, IssuanceApikeyData, IssuanceApikeyError, IssuanceApikeyResponse, GetAddressData, GetAddressError, GetAddressResponse, SendJejuYouthDreamServiceData, SendJejuYouthDreamServiceError, SendJejuYouthDreamServiceResponse, SaveExternalClientData, SaveExternalClientError, SaveExternalClientResponse, GetUniversityListData, GetNoticeData, GetIclLoanInterestChangeHisData, GetCountryListData, GetAgreementData, GetWelloPolicyApplyHisListData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportQueryKey = (options: Options<SaveReportData>) => createQueryKey('saveReport', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportOptions = (options: Options<SaveReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportMutation = (options?: Partial<Options<SaveReportData>>) => {
    const mutationOptions: UseMutationOptions<SaveReportResponse, SaveReportError, Options<SaveReportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheckQueryKey = (options: Options<GetReportStatusCheckData>) => createQueryKey('getReportStatusCheck', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheckOptions = (options: Options<GetReportStatusCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheckMutation = (options?: Partial<Options<GetReportStatusCheckData>>) => {
    const mutationOptions: UseMutationOptions<GetReportStatusCheckResponse, GetReportStatusCheckError, Options<GetReportStatusCheckData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlistQueryKey = (options: Options<GetReportHistoryListData>) => createQueryKey('getReportHistoryList', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlistOptions = (options: Options<GetReportHistoryListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlistQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlistMutation = (options?: Partial<Options<GetReportHistoryListData>>) => {
    const mutationOptions: UseMutationOptions<GetReportHistoryListResponse, GetReportHistoryListError, Options<GetReportHistoryListData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlist({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetailQueryKey = (options: Options<GetReportHistoryData>) => createQueryKey('getReportHistory', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetailOptions = (options: Options<GetReportHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetailQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetailMutation = (options?: Partial<Options<GetReportHistoryData>>) => {
    const mutationOptions: UseMutationOptions<GetReportHistoryResponse, GetReportHistoryError, Options<GetReportHistoryData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetail({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterestQueryKey = (options: Options<GetLoanInterestListData>) => createQueryKey('getLoanInterestList', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterestOptions = (options: Options<GetLoanInterestListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterestQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterestMutation = (options?: Partial<Options<GetLoanInterestListData>>) => {
    const mutationOptions: UseMutationOptions<GetLoanInterestListResponse, GetLoanInterestListError, Options<GetLoanInterestListData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheckOptions = (options?: Options<HealthCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheckMutation = (options?: Partial<Options<HealthCheckData>>) => {
    const mutationOptions: UseMutationOptions<HealthCheckResponse, HealthCheckError, Options<HealthCheckData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewalQueryKey = (options?: Options<RenewalEncKeyData>) => createQueryKey('renewalEncKey', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewalOptions = (options?: Options<RenewalEncKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewalQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewalMutation = (options?: Partial<Options<RenewalEncKeyData>>) => {
    const mutationOptions: UseMutationOptions<RenewalEncKeyResponse, RenewalEncKeyError, Options<RenewalEncKeyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewal({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheckQueryKey = (options: Options<GetEligibilityCheckData>) => createQueryKey('getEligibilityCheck', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheckOptions = (options: Options<GetEligibilityCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheckMutation = (options?: Partial<Options<GetEligibilityCheckData>>) => {
    const mutationOptions: UseMutationOptions<GetEligibilityCheckResponse, GetEligibilityCheckError, Options<GetEligibilityCheckData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpushQueryKey = (options: Options<SendDeptReportAppPushData>) => createQueryKey('sendDeptReportAppPush', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpushOptions = (options: Options<SendDeptReportAppPushData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpush({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpushQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpushMutation = (options?: Partial<Options<SendDeptReportAppPushData>>) => {
    const mutationOptions: UseMutationOptions<SendDeptReportAppPushResponse, SendDeptReportAppPushError, Options<SendDeptReportAppPushData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpush({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewalQueryKey = (options?: Options<RenewalApiKeyData>) => createQueryKey('renewalApiKey', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewalOptions = (options?: Options<RenewalApiKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewalQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewalMutation = (options?: Partial<Options<RenewalApiKeyData>>) => {
    const mutationOptions: UseMutationOptions<RenewalApiKeyResponse, RenewalApiKeyError, Options<RenewalApiKeyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewal({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuanceQueryKey = (options: Options<IssuanceApikeyData>) => createQueryKey('issuanceApikey', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuanceOptions = (options: Options<IssuanceApikeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuanceQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuanceMutation = (options?: Partial<Options<IssuanceApikeyData>>) => {
    const mutationOptions: UseMutationOptions<IssuanceApikeyResponse, IssuanceApikeyError, Options<IssuanceApikeyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuance({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddressQueryKey = (options: Options<GetAddressData>) => createQueryKey('getAddress', options);

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddressOptions = (options: Options<GetAddressData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddressQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddressMutation = (options?: Partial<Options<GetAddressData>>) => {
    const mutationOptions: UseMutationOptions<GetAddressResponse, GetAddressError, Options<GetAddressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdreamQueryKey = (options: Options<SendJejuYouthDreamServiceData>) => createQueryKey('sendJejuYouthDreamService', options);

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdreamOptions = (options: Options<SendJejuYouthDreamServiceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdream({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdreamQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdreamMutation = (options?: Partial<Options<SendJejuYouthDreamServiceData>>) => {
    const mutationOptions: UseMutationOptions<SendJejuYouthDreamServiceResponse, SendJejuYouthDreamServiceError, Options<SendJejuYouthDreamServiceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdream({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclientQueryKey = (options: Options<SaveExternalClientData>) => createQueryKey('saveExternalClient', options);

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclientOptions = (options: Options<SaveExternalClientData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclient({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclientQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclientMutation = (options?: Partial<Options<SaveExternalClientData>>) => {
    const mutationOptions: UseMutationOptions<SaveExternalClientResponse, SaveExternalClientError, Options<SaveExternalClientData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclient({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversityQueryKey = (options: Options<GetUniversityListData>) => createQueryKey('getUniversityList', options);

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversityOptions = (options: Options<GetUniversityListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversityQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnoticeQueryKey = (options: Options<GetNoticeData>) => createQueryKey('getNotice', options);

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnoticeOptions = (options: Options<GetNoticeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnotice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnoticeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistoryQueryKey = (options?: Options<GetIclLoanInterestChangeHisData>) => createQueryKey('getIclLoanInterestChangeHis', options);

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistoryOptions = (options?: Options<GetIclLoanInterestChangeHisData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountryQueryKey = (options: Options<GetCountryListData>) => createQueryKey('getCountryList', options);

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountryOptions = (options: Options<GetCountryListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreementQueryKey = (options?: Options<GetAgreementData>) => createQueryKey('getAgreement', options);

export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreementOptions = (options?: Options<GetAgreementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreementQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACEQueryKey = (options: Options<GetWelloPolicyApplyHisListData>) => createQueryKey('getWelloPolicyApplyHisList', options);

export const getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACEOptions = (options: Options<GetWelloPolicyApplyHisListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACEQueryKey(options)
    });
};